@if (themeService.featureEnabled()) {
  <div class="theme-toggle" role="radiogroup" aria-label="Theme preference">
    @for (option of options(); track option.value) {
      <button
        type="button"
        class="theme-toggle__option"
        [class.theme-toggle__option--active]="themeService.preference() === option.value"
        role="radio"
        [attr.aria-checked]="themeService.preference() === option.value"
        [attr.aria-label]="option.label"
        [title]="option.label"
        (click)="select(option.value)"
      >
        <i [class]="option.icon" aria-hidden="true"></i>
      </button>
    }
  </div>
}
